import { Alert, AlertIcon, AlertTitle, Box, Button, Icons, styled } from '@arpeggi/ui'
import { FC } from 'react'
import { Link } from 'react-router-dom'
import Text from '../../../__legacy__/components/core/Text/Text'
import { InternalEndpoint } from '../../../__legacy__/components/Internal'

const RedirectsTableTitle: FC = () => {
  return (
    <Box row justifyBetween alignCenter>
      <Text size="24">Redirects</Text>
      <Link to={`/${InternalEndpoint}/redirects/create`}>
        <Button size="md" prefixIcon={<Icons.Plus />}>
          Add redirect
        </Button>
      </Link>
    </Box>
  )
}

const RedirectsTableInfoDisclaimer: FC = () => {
  return (
    <Alert>
      <AlertIcon />
      <AlertTitle>
        Redirects defined by developers in the code base will still take precedence.
      </AlertTitle>
    </Alert>
  )
}

const NoResultsTableText = styled(Text, { marginTop: '$16' })

const RedirectsTableContainer = styled('div', {
  display: 'flex',
  flexDirection: 'column',
  gap: '16px'
})

export const RedirectTable = {
  Header: RedirectsTableTitle,
  InfoDisclaimer: RedirectsTableInfoDisclaimer,
  Container: RedirectsTableContainer,
  NoResultsText: NoResultsTableText
}
